






import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: new Array<string>(),
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      if(context.root.$route.query.error_kind){
        const error_kind = context.root.$route.query.error_kind as string;
        let message = "";
        if(error_kind == "user_not_exists"){
           message = "ユーザー情報がデータベースから削除されています。ログイン画面からやり直してください。";
        }else if(error_kind == "account_mismatch"){
           message = "認証したGoogleアカウントはログインしているユーザーとメールアドレスが異なります。ログインしているユーザーのメールアドレスと一致するGoogleアカウントで認証してください。";
        }
        alert(message);
        context.root.$router.push('/teacher_site/sheet_list').catch(() => {});
      }else{
        // 認証成功の場合は遷移先の画面へ
        context.root.$store.commit("setGauthCredentials", context.root.$route.query.credentials);
        context.root.$router.push(context.root.$store.state.gauthRedirectPath).catch(err => {});
      }
    });

    return {
      ...toRefs(state),
    }
  }
})
